/**
 * A class defines store opening and closing times on a particular day.
 */
export class StoreWorkingTime {
  openingTime: string;
  closingTime: string;

  /**
   * @param openingTime the moment in time when the store opens.
   * @param closingTime the moment in time when the store closes.
   */
  constructor(openingTime: string, closingTime: string) {
    this.openingTime = openingTime;
    this.closingTime = closingTime;
  }
}
